import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInformation = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14 16H13.3333C12.9797 16 12.6405 15.8595 12.3905 15.6095C12.1404 15.3594 12 15.0203 12 14.6667V11.3333C12 11.1565 11.9297 10.9869 11.8047 10.8619C11.6797 10.7369 11.5101 10.6667 11.3333 10.6667H10.6666"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6667 7.33334C11.6008 7.33334 11.5363 7.35289 11.4815 7.38952C11.4267 7.42615 11.384 7.47821 11.3587 7.53912C11.3335 7.60002 11.3269 7.66705 11.3398 7.73171C11.3526 7.79637 11.3844 7.85576 11.431 7.90238C11.4776 7.949 11.537 7.98074 11.6017 7.99361C11.6663 8.00647 11.7334 7.99987 11.7943 7.97464C11.8552 7.94941 11.9072 7.90668 11.9439 7.85187C11.9805 7.79705 12 7.7326 12 7.66668C12 7.57827 11.9649 7.49349 11.9024 7.43097C11.8399 7.36846 11.7551 7.33334 11.6667 7.33334Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInformation.displayName = 'SvgInformation';
export default SvgInformation;
